DOMReady( function(){
  /* ========================================================================
  * cartouches
  * ======================================================================== */
  if( document.querySelector('.cartouches-container') && document.querySelectorAll('.cartouches-container .cartouche-seemore').length > 0 )
  {
    [... document.querySelectorAll('.cartouches-container .cartouche-seemore')].map( elt => {
      elt.addEventListener('click', function(e){
        e.preventDefault();
        this.parentElement.querySelector('.cartouche-seeless').style.display = 'block';
        elt.style.display = 'none';
        this.parentElement.querySelectorAll('.cartouche').forEach((cartouche) => {
          cartouche.style.display =  'inline-block';
        });
      });

    });

    [... document.querySelectorAll('.cartouches-container .cartouche-seeless')].map( elt => {
      elt.addEventListener('click', function(e){
        e.preventDefault();
        this.parentElement.querySelector('.cartouche-seemore').style.display = 'block';
        elt.style.display = 'none';
        let  cartouches = this.parentElement.querySelectorAll('.cartouche');


        for(let i=0;i<cartouches.length;i++)
        {
          if(i > 2){
            cartouches[i].style.display =  'none';
          }

        };
      });

    });
  }
});
